/* ruleUiOnlyFields.js */

/**
 * Fields that `_mapRulesForSlick` stamps onto each rule for in-grid display
 * (severity / source / OS lookup maps, dirty flag, formatted command-result
 * string, etc.). These are not part of the canonical rule shape — strip them
 * before writing rules back to the entity (see `_generateRules`) or
 * projecting them into the JSON edit pane.
 *
 * Lives in its own module so both renderers can import it without
 * circular-require trouble (AuditPolicyDetailsViewRenderer ↔
 * EditAuditPolicyComponent ↔ EditAuditPolicyRenderer all reference each
 * other directly).
 */
const RULE_UI_ONLY_FIELDS = [
    "id",
    "sevMap",
    "sourceMap",
    "conceptItem",
    "isReadOnly",
    "osMap",
    "dirty",
    "commandResult",
];

module.exports = {RULE_UI_ONLY_FIELDS};
